module.exports = __webpack_public_path__ + "img/food.e52627c5.png";